import { jsxs, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const ShowerIcon = (props)=>/*#__PURE__*/ jsxs("svg", _objectSpreadProps(_objectSpread({}, props), {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M7.14309 2.25823C7.36081 2.33659 7.646 2.4 8.00023 2.4C8.35447 2.4 8.63966 2.33659 8.85738 2.25823V0.228571C8.85738 0.102335 8.75504 0 8.62881 0H7.37166C7.24543 0 7.14309 0.102335 7.14309 0.228572V2.25823Z",
                fill: props.fill
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M9.35633 3.0431C9.02311 3.18902 8.57012 3.31429 8.00023 3.31429C7.43034 3.31429 6.97736 3.18901 6.64413 3.0431L3.91084 6.45669C3.65212 6.67163 3.65011 7.04708 3.9467 7.20575C4.57501 7.54189 5.8295 8.00001 8.00023 8.00001C10.171 8.00001 11.4255 7.54189 12.0538 7.20575C12.3504 7.04708 12.3483 6.67163 12.0896 6.45669L9.35633 3.0431Z",
                fill: props.fill
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M8.95237 13.9047C8.95237 14.4307 8.52598 14.8571 7.99999 14.8571C7.47401 14.8571 7.04761 14.4307 7.04761 13.9047C7.04761 13.3787 7.99999 12 7.99999 12C7.99999 12 8.95237 13.3787 8.95237 13.9047Z",
                fill: props.fill
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M13.1428 14.8571C13.6688 14.8571 14.0952 14.4307 14.0952 13.9047C14.0952 13.3787 13.1428 12 13.1428 12C13.1428 12 12.1905 13.3787 12.1905 13.9047C12.1905 14.4307 12.6169 14.8571 13.1428 14.8571Z",
                fill: props.fill
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M11.5194 11.0476C11.5194 11.5736 11.093 12 10.5671 12C10.0411 12 9.61467 11.5736 9.61467 11.0476C9.61467 10.5216 10.5671 9.14282 10.5671 9.14282C10.5671 9.14282 11.5194 10.5216 11.5194 11.0476Z",
                fill: props.fill
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M5.43312 12C5.95911 12 6.3855 11.5736 6.3855 11.0476C6.3855 10.5216 5.43312 9.14282 5.43312 9.14282C5.43312 9.14282 4.48074 10.5216 4.48074 11.0476C4.48074 11.5736 4.90714 12 5.43312 12Z",
                fill: props.fill
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M3.80942 13.9047C3.80942 14.4307 3.38303 14.8571 2.85704 14.8571C2.33106 14.8571 1.90466 14.4307 1.90466 13.9047C1.90466 13.3787 2.85704 12 2.85704 12C2.85704 12 3.80942 13.3787 3.80942 13.9047Z",
                fill: props.fill
            })
        ]
    }));
ShowerIcon.defaultProps = {
    width: 16,
    height: 16,
    fill: 'currentColor'
};

export { ShowerIcon as default };
//# sourceMappingURL=Shower.mjs.map
